import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { updateBenefitApi } from "./benefitApi";

export const updateBenefitRequest = createAsyncThunk(
  "updateBenefitRequest/contact",
  async (payload: any) => {
    try {
      const response = await updateBenefitApi(payload);
      return response;
    } catch (error) {
      throw error;
    }
  }
);

interface IInitialState {
  benefitUpdate: any;
  message: string;
  pageIsLoading: boolean;
  isSuccess: boolean;
}

const initialState: IInitialState = {
  benefitUpdate: {},
  message: "",
  pageIsLoading: false,
  isSuccess: false,
};

const benefitSlice = createSlice({
  name: "contact",
  initialState: initialState,
  reducers: {
    resetBenefitMessage: (state) => {
      state.message = "";
    },
    resetBenefitSuccess: (state) => {
      state.isSuccess = false;
    },
  },
  extraReducers: (builder) => {
    // get job reducer
    builder.addCase(updateBenefitRequest.pending, (state) => {
      state.pageIsLoading = true;
    });
    builder.addCase(updateBenefitRequest.fulfilled, (state, action) => {
      if (action.payload.status === 1000) {
        state.benefitUpdate = action.payload.data;
        state.isSuccess = true;
        state.pageIsLoading = false;
      } else {
        state.message = "someting went wrong";
        state.pageIsLoading = false;
      }
    });
    builder.addCase(updateBenefitRequest.rejected, (state) => {
      state.message = "someting went wrong on server";
      state.pageIsLoading = false;
    });
  },
});

export const { resetBenefitMessage, resetBenefitSuccess } =
  benefitSlice.actions;
export default benefitSlice.reducer;
